import { createBrowserHistory } from 'history';
import historyLocationSearchParamsDecorator from './lib/historyLocationSearchParamsDecorator';

const history = createBrowserHistory();

export default historyLocationSearchParamsDecorator(history);
